import { Injectable } from '@angular/core';
import { ToastInterface } from '../interfaces/toast.interface';

@Injectable()
export class ToastService {

    /**
     * Toast message defaults holder.
     *
     * @type {{}}
     */
    protected messages: Object = {};

    /**
     * Toast defaults holder.
     *
     * @type {{}}
     */
    protected defaults: ToastInterface = {};

    /**
     * Constructor.
     */
    constructor() {
        // Set Toast defaults
        this.defaults = {
            element: null,
            style: 'simple',
            type: 'success',
            showClose: false,
            position: 'bottom-right',
            timeout: 4000,
        };

        // Create Toast message defaults
        this.createMessageDefaults();
    }

    /**
     * Show a success Toast with default 'saved' message.
     */
    public successSaved() {
        this.success('saved');
    }

    /**
     * Show a success Toast with default 'updated' message.
     */
    public successUpdated() {
        this.success('updated');
    }

    /**
     * Show a success Toast with default 'deleted' message.
     */
    public successDeleted() {
        this.success('deleted');
    }

    /**
     * Show a success Toast.
     *
     * @param {string} message
     * @param {string} defaultName
     * @param additional
     */
    public success(defaultName: string = 'success', message?: string, additional?: ToastInterface) {
        this.custom('success', message, defaultName, additional);
    }

    /**
     * Show a info Toast.
     *
     * @param {string} message
     * @param {string} defaultName
     * @param additional
     */
    public info(defaultName: string, message?: string, additional?: ToastInterface) {
        this.custom('info', message, defaultName, additional);
    }

    /**
     * Show a success Toast.
     *
     * @param {string} message
     * @param {string} defaultName
     * @param additional
     */
    public warning(defaultName: string, message?: string, additional?: ToastInterface) {
        this.custom('warning', message, defaultName, additional);
    }

    /**
     * Show a success Toast.
     *
     * @param {string} message
     * @param {string} defaultName
     * @param additional
     */
    public error(defaultName = 'error', message?: string, additional?: ToastInterface) {
        this.custom('error', message, defaultName, additional);
    }

    /**
     * Show a custom Toast.
     *
     * @param {string} type
     * @param {string} message
     * @param {string | ToastInterface} defaultName
     * @param {ToastInterface} additional
     */
    public custom(type: string, message: string, defaultName?: string | ToastInterface, additional?: ToastInterface) {
        const options = this.create(type, message, defaultName, additional);

        this.show(options);
    }

    /**
     * Create the Toast options.
     *
     * @param {string} type
     * @param {string} message
     * @param {string | ToastInterface} defaultName
     * @param {ToastInterface} additional
     */
    public create(type: string, message: string, defaultName?: string | ToastInterface, additional?: ToastInterface) {
        const options = Object.assign({}, this.defaults);

        if (!message && defaultName) {
            if (typeof defaultName === 'string') {
                message = this.getDefaultMessage(defaultName);
            }
        }

        /*
         * If the method receives only three arguments, we'll check if the third argument is an
         * object. If so we'll presume that the third argument is an options object.
         */
        if (arguments.length === 3) {
            if (typeof defaultName === 'object') {
                additional = defaultName;
            }
        }

        if (additional) {
            Object.assign(options, additional);
        }

        options['message'] = message;
        options['type']    = type;

        return options;
    }

    /**
     * Show a Toast with the given options.
     *
     * @param {ToastInterface} options
     */
    public show(options: ToastInterface) {

        if (options.element !== undefined && options.element !== null) {
            (<any>$(options.element)).pgNotification(options).show();
        } else {
            (<any>$('html body:first')).pgNotification(options).show();
        }
    }

    /**
     * Get a default message.
     *
     * @param {string} name
     */
    public getDefaultMessage(name: string) {
        return this.messages[name];
    }

    /**
     * Remove a default message.
     *
     * @param {string} name
     */
    public removeMessageDefault(name: string) {
        delete this.messages[name];
    }

    /**
     * Create a default message.
     *
     * @param {string} name
     * @param {string} message
     */
    protected createMessageDefault(name: string, message: string) {
        this.messages[name] = message;
    }

    /**
     * Create all default messages.
     */
    protected createMessageDefaults() {
        this.createMessageDefault('success', 'Success');
        this.createMessageDefault('saved', 'Saved successfully');
        this.createMessageDefault('updated', 'Updated successfully');
        this.createMessageDefault('deleted', 'Deleted successfully');
        this.createMessageDefault('error', 'Something went wrong');
        this.createMessageDefault('error-api', 'Something went wrong while contacting the server');
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/toast/services/toast.service.ts